/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 12H19M19 12L17 10M19 12L17 14M9 12H5M5 12L7 10M5 12L7 14M12 9V5M12 5L10 7M12 5L14 7M12 15V19M12 19L10 17M12 19L14 17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M15 12H19M19 12L17 10M19 12L17 14M9 12H5M5 12L7 10M5 12L7 14M12 9V5M12 5L10 7M12 5L14 7M12 15V19M12 19L10 17M12 19L14 17M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM12.5303 4.46967C12.2374 4.17678 11.7626 4.17678 11.4697 4.46967L9.46967 6.46967C9.17678 6.76256 9.17678 7.23744 9.46967 7.53033C9.76256 7.82322 10.2374 7.82322 10.5303 7.53033L11.25 6.81066V9C11.25 9.41421 11.5858 9.75 12 9.75C12.4142 9.75 12.75 9.41421 12.75 9V6.81066L13.4697 7.53033C13.7626 7.82322 14.2374 7.82322 14.5303 7.53033C14.8232 7.23744 14.8232 6.76256 14.5303 6.46967L12.5303 4.46967ZM7.53033 10.5303C7.82322 10.2374 7.82322 9.76256 7.53033 9.46967C7.23744 9.17678 6.76256 9.17678 6.46967 9.46967L4.46967 11.4697C4.17678 11.7626 4.17678 12.2374 4.46967 12.5303L6.46967 14.5303C6.76256 14.8232 7.23744 14.8232 7.53033 14.5303C7.82322 14.2374 7.82322 13.7626 7.53033 13.4697L6.81066 12.75H9C9.41421 12.75 9.75 12.4142 9.75 12C9.75 11.5858 9.41421 11.25 9 11.25H6.81066L7.53033 10.5303ZM17.5303 9.46967C17.2374 9.17678 16.7626 9.17678 16.4697 9.46967C16.1768 9.76256 16.1768 10.2374 16.4697 10.5303L17.1893 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H17.1893L16.4697 13.4697C16.1768 13.7626 16.1768 14.2374 16.4697 14.5303C16.7626 14.8232 17.2374 14.8232 17.5303 14.5303L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L17.5303 9.46967ZM12.75 15C12.75 14.5858 12.4142 14.25 12 14.25C11.5858 14.25 11.25 14.5858 11.25 15V17.1893L10.5303 16.4697C10.2374 16.1768 9.76256 16.1768 9.46967 16.4697C9.17678 16.7626 9.17678 17.2374 9.46967 17.5303L11.4697 19.5303C11.7626 19.8232 12.2374 19.8232 12.5303 19.5303L14.5303 17.5303C14.8232 17.2374 14.8232 16.7626 14.5303 16.4697C14.2374 16.1768 13.7626 16.1768 13.4697 16.4697L12.75 17.1893V15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M15 12H19M19 12L17 10M19 12L17 14M9 12H5M5 12L7 10M5 12L7 14M12 9V5M12 5L10 7M12 5L14 7M12 15V19M12 19L10 17M12 19L14 17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 12H19M19 12L17 10M19 12L17 14M9 12H5M5 12L7 10M5 12L7 14M12 9V5M12 5L10 7M12 5L14 7M12 15V19M12 19L10 17M12 19L14 17M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967L14.5303 6.46967C14.8232 6.76256 14.8232 7.23744 14.5303 7.53033C14.2374 7.82322 13.7626 7.82322 13.4697 7.53033L12.75 6.81066V9C12.75 9.41421 12.4142 9.75 12 9.75C11.5858 9.75 11.25 9.41421 11.25 9V6.81066L10.5303 7.53033C10.2374 7.82322 9.76256 7.82322 9.46967 7.53033C9.17678 7.23744 9.17678 6.76256 9.46967 6.46967L11.4697 4.46967ZM7.53033 9.46967C7.82322 9.76256 7.82322 10.2374 7.53033 10.5303L6.81066 11.25H9C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75H6.81066L7.53033 13.4697C7.82322 13.7626 7.82322 14.2374 7.53033 14.5303C7.23744 14.8232 6.76256 14.8232 6.46967 14.5303L4.46967 12.5303C4.17678 12.2374 4.17678 11.7626 4.46967 11.4697L6.46967 9.46967C6.76256 9.17678 7.23744 9.17678 7.53033 9.46967ZM16.4697 9.46967C16.7626 9.17678 17.2374 9.17678 17.5303 9.46967L19.5303 11.4697C19.8232 11.7626 19.8232 12.2374 19.5303 12.5303L17.5303 14.5303C17.2374 14.8232 16.7626 14.8232 16.4697 14.5303C16.1768 14.2374 16.1768 13.7626 16.4697 13.4697L17.1893 12.75H15C14.5858 12.75 14.25 12.4142 14.25 12C14.25 11.5858 14.5858 11.25 15 11.25H17.1893L16.4697 10.5303C16.1768 10.2374 16.1768 9.76256 16.4697 9.46967ZM12 14.25C12.4142 14.25 12.75 14.5858 12.75 15V17.1893L13.4697 16.4697C13.7626 16.1768 14.2374 16.1768 14.5303 16.4697C14.8232 16.7626 14.8232 17.2374 14.5303 17.5303L12.5303 19.5303C12.2374 19.8232 11.7626 19.8232 11.4697 19.5303L9.46967 17.5303C9.17678 17.2374 9.17678 16.7626 9.46967 16.4697C9.76256 16.1768 10.2374 16.1768 10.5303 16.4697L11.25 17.1893V15C11.25 14.5858 11.5858 14.25 12 14.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
